module.exports = __webpack_public_path__ + "media/images/app/products/Bracelets_candies_pieces-ba4ae9d3cb2c77e36cadd426fa7fc986.webp";